// extracted by mini-css-extract-plugin
export default {"base":"vp_El5dD","label":"vp_h5qHf","thinking-fade":"vp_pECBz","dots":"vp_jgj0V","dot":"vp_ladgK","thinking-bounce":"vp_dl39p"};